import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { usePaymentMethods } from '../../../hooks/appointments/usePaymentMethods';

export default function PaymentMethodSelect ({ onSelect, paymentMethodId, disabledOptions=[] }) {

    const {paymentMethods, loading} = usePaymentMethods();

    const handleChange = (e) => {
      onSelect(e.target.value);
    };

    return (
        <React.Fragment>
          <FormControl fullWidth>
            <InputLabel>
              Select Payment Method
            </InputLabel>
            <Select
              value={paymentMethodId}
              label="Select Payment Method"
              onChange={handleChange}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 250, // adjust as needed
                  },
                },
              }}
            >
              {!loading && paymentMethods?.map((paymentMethod) => (
                !disabledOptions.includes(paymentMethod.id) ? <MenuItem value={paymentMethod.id} sx={{ my: 1 }}>{paymentMethod.name}</MenuItem> : null
              ))}
            </Select>
          </FormControl>
        </React.Fragment>
    );
}